import React from 'react'
import Dropzone from 'react-dropzone'

class ArtistPhoto extends React.Component {
  constructor(props) {
    super(props)
    this.state = { preview: null }
    this.onChange = this.onChange.bind(this)
  }

  onChange(files) {
    console.log(files);
  	// For Redux form
    if (this.props.input) {
      const {input: {onChange}} = this.props
      onChange(files[0])
    }
    else if(this.props.onChange){
    	this.props.onChange(files[0])
    }
    else{
    	console.warn('redux-form-dropzone => Forgot to pass onChange props ?');
    }

    this.setState({ preview: files[0].preview })
  }

  render() {
    const { preview } = this.state
    const {accept, className, multiple, artistphoto, projectid } = this.props
    let dropzoneRef

    return (

      <div className="small-12 medium-2 column">
        <Dropzone 
          {...this.props}
          ref={(node) => { dropzoneRef = node; }}
          onDrop={ this.onChange } 
          accept={accept} 
          className={className} 
          multiple={multiple} ></Dropzone>
        <div className="photo-wrapper">
          {
            !projectid
            ? <span 
              className="fa-stack fa-lg photo-edit" 
              onClick={(e) => { e.preventDefault(); dropzoneRef.open() }}>
              <i className="fa fa-circle fa-stack-2x"></i>
              <i className="fa fa-pencil fa-stack-1x fa-inverse"></i>
            </span>
            : ''
          }
          { 
            preview 
            ? <img src={ preview } alt="" />
            : <img src={artistphoto} alt="" />
          }
        </div>
        
      </div>
    )
  }
}
export default ArtistPhoto


// WEBPACK FOOTER //
// ./src/components/ArtistPhoto.js